// ─── Éditeur du PLAN 2D d'un niveau (brouillon → 💾) ──────────────
// Extrait d'EcranPlans (découpage). Grille (colonnes/lignes), murs (brosses
// cloison/mur/porte/fenêtre), placement/redimensionnement/forme des tuiles,
// chips « à placer ». Toutes les mutations passent par majDraft (brouillon).
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, ScrollView } from 'react-native';
import { useUI, useT } from '@mop/core';
import {
  majPlanCols, majPlanRows, poserMur, placerPlan, redimPlan, basculerCellZone,
} from './services/plan';
import { makeStylesPlans } from './stylesPlans';
import PlanGrid from './ui/PlanGrid';

const BROSSES = [['fin', '▏', 'inventaire.planCloison'], ['epais', '▍', 'inventaire.planMur'], ['porte', '🚪', 'inventaire.planPorte'], ['fenetre', '🪟', 'inventaire.planFenetre']];

export default function EditeurPlan2D({
  parent, courantId, cols, rows, nonPlaces, majDraft,
  murMode, setMurMode, brosse, setBrosse, formeMode, setForme, planSel, setPlanSel,
  onTapTuilePlan, ouvrirFormEmp, compteDe,
}) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStylesPlans(UI), [UI]);
  return (
    <ScrollView contentContainerStyle={s.corps} keyboardShouldPersistTaps="handled">
      <Text style={s.editTitre}>{t('plans.editerPlanDe', { nom: parent?.nom })}</Text>
      <View style={s.ctrl}>
        <Text style={s.ctrlLbl}>{t('plans.colonnesN', { n: cols })}</Text>
        <TouchableOpacity style={s.step} onPress={() => majDraft(tr => majPlanCols(tr, courantId, -1))}><Text style={s.stepTxt}>−</Text></TouchableOpacity>
        <TouchableOpacity style={s.step} onPress={() => majDraft(tr => majPlanCols(tr, courantId, 1))}><Text style={s.stepTxt}>＋</Text></TouchableOpacity>
        <Text style={[s.ctrlLbl, { marginLeft: 8 }]}>{t('plans.lignesN', { n: rows })}</Text>
        <TouchableOpacity style={s.step} onPress={() => majDraft(tr => majPlanRows(tr, courantId, -1))}><Text style={s.stepTxt}>−</Text></TouchableOpacity>
        <TouchableOpacity style={s.step} onPress={() => majDraft(tr => majPlanRows(tr, courantId, 1))}><Text style={s.stepTxt}>＋</Text></TouchableOpacity>
      </View>
      <View style={s.ctrl}>
        <TouchableOpacity style={[s.chip, !murMode && s.chipOn]} onPress={() => setMurMode(false)}>
          <Text style={[s.chipTxt, !murMode && s.chipTxtOn]}>📦 {t('inventaire.planPlacer')}</Text>
        </TouchableOpacity>
        <TouchableOpacity style={[s.chip, murMode && s.chipOn]} onPress={() => { setMurMode(true); setForme(false); setPlanSel(null); }}>
          <Text style={[s.chipTxt, murMode && s.chipTxtOn]}>🧱 {t('inventaire.planMurs')}</Text>
        </TouchableOpacity>
      </View>
      {murMode && (
        <View style={s.ctrl}>
          {BROSSES.map(([b, ic, lb]) => (
            <TouchableOpacity key={b} style={[s.chip, brosse === b && s.chipOn]} onPress={() => setBrosse(b)}>
              <Text style={[s.chipTxt, brosse === b && s.chipTxtOn]}>{ic} {t(lb)}</Text>
            </TouchableOpacity>
          ))}
        </View>
      )}
      <PlanGrid
        parent={parent} flux={false} selId={planSel}
        onTapTuile={onTapTuilePlan}
        onLongPressTuile={(n) => ouvrirFormEmp(null, n.id)}
        onTapCase={(x, y) => {
          if (!planSel) return;
          if (formeMode) majDraft(tr => basculerCellZone(tr, planSel, x, y));
          else           majDraft(tr => placerPlan(tr, planSel, x, y));
        }}
        murEdit={murMode}
        onTapMur={(o, x, y) => majDraft(tr => poserMur(tr, courantId, o, x, y, brosse))}
        formeEdit={formeMode && !!planSel}
        compteDe={compteDe}
      />
      {!murMode && nonPlaces.length > 0 && (
        <View style={s.aplacer}>
          <Text style={s.aplacerTitre}>{t('plans.aPlacerTitre')}</Text>
          <View style={s.aplacerWrap}>
            {nonPlaces.map(n => (
              <TouchableOpacity key={n.id} style={[s.aplacerChip, planSel === n.id && s.aplacerChipOn]}
                onPress={() => setPlanSel(x => (x === n.id ? null : n.id))}>
                <Text style={{ fontSize: 15 }}>{n.emoji || '📍'}</Text>
                <Text style={[s.aplacerTxt, planSel === n.id && s.aplacerTxtOn]} numberOfLines={1}>{n.nom}</Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
      )}
      {murMode ? (
        <Text style={s.aide}>{t('plans.aideMurs')}</Text>
      ) : planSel ? (
        <View style={s.ctrl}>
          <TouchableOpacity style={[s.chip, formeMode && s.chipOn]} onPress={() => setForme(v => !v)}>
            <Text style={[s.chipTxt, formeMode && s.chipTxtOn]}>🧩 {t('inventaire.planForme')}</Text>
          </TouchableOpacity>
          {!formeMode && (
            <>
              <Text style={s.ctrlLbl}>↔</Text>
              <TouchableOpacity style={s.step} onPress={() => majDraft(tr => redimPlan(tr, planSel, 'w', -1))}><Text style={s.stepTxt}>−</Text></TouchableOpacity>
              <TouchableOpacity style={s.step} onPress={() => majDraft(tr => redimPlan(tr, planSel, 'w', 1))}><Text style={s.stepTxt}>＋</Text></TouchableOpacity>
              <Text style={s.ctrlLbl}>↕</Text>
              <TouchableOpacity style={s.step} onPress={() => majDraft(tr => redimPlan(tr, planSel, 'h', -1))}><Text style={s.stepTxt}>−</Text></TouchableOpacity>
              <TouchableOpacity style={s.step} onPress={() => majDraft(tr => redimPlan(tr, planSel, 'h', 1))}><Text style={s.stepTxt}>＋</Text></TouchableOpacity>
            </>
          )}
        </View>
      ) : (
        <Text style={s.aide}>
          {t('plans.aidePlacement')}
        </Text>
      )}
      <View style={{ height: 40 }} />
    </ScrollView>
  );
}
